import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export interface IGetPayrollChecksParams {
  readonly companyID?: string;
  readonly payrollRunID?: string;
}

export const getPayrollChecks = (axios: IAxiosInstance) => {
  return async (params: IGetPayrollChecksParams) => {
    const { companyID, payrollRunID } = params;
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetPayrollChecksResponse"]
    >(`/api/getPayrollChecks`, {
      params: {
        companyID,
        payrollRunID,
      },
    });
    const resData = response.data;

    if (resData.success) {
      return resData;
    }

    throw new Error("Something went wrong");
  };
};
